/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Period_Base_MonthInputs */

const es_components_upgrade_plan_modal_period_base_month = /** @type {(inputs: Components_Upgrade_Plan_Modal_Period_Base_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mes base`)
};

const en_components_upgrade_plan_modal_period_base_month = /** @type {(inputs: Components_Upgrade_Plan_Modal_Period_Base_MonthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`base month`)
};

/**
* | output |
* | --- |
* | "base month" |
*
* @param {Components_Upgrade_Plan_Modal_Period_Base_MonthInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_period_base_month = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Period_Base_MonthInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Period_Base_MonthInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_period_base_month(inputs)
	return en_components_upgrade_plan_modal_period_base_month(inputs)
});
export { components_upgrade_plan_modal_period_base_month as "components.upgrade_plan_modal.period.base_month" }